(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  const recommendations = document.querySelector('.product-recommendations');

  if (recommendations) {
    fetch(recommendations.dataset.url).then(response => response.text()).then(html => {
      const doc = document.createElement('div');
      doc.innerHTML = html;

      const rendered = doc.querySelector('.product-recommendations');

      if (rendered && rendered.innerHTML.trim()) {
        recommendations.innerHTML = rendered.innerHTML;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
